export default "__VITE_ASSET__BBrjn1ud__"